import BaseSelectBox from 'components/atoms/base-select-box';
import { useTranslation } from 'react-i18next';

import type { Languages } from 'infrastructure/enums';
import type { FC } from 'react';

interface LanguageSelectProps {
  value: Languages | undefined;
  onChange: (value: Languages) => void;
}

const LanguageSelect: FC<LanguageSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <BaseSelectBox
      minWidth="150px"
      placeholder={t('labels.language')}
      value={value}
      options={[
        { label: 'English', value: 'en' },
        { label: 'Spanish', value: 'es' },
      ]}
      onChange={onChange}
      allowClear
    />
  );
};
export default LanguageSelect;
